import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiAdminsList, apiAdminsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/admins/getData', async datas => {
    const { data } = await apiAdminsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/admins/getView', async id => {
    if (!id) return viewData
    const { data } = await apiAdminsView(id)
    data.image = ''
    return data
})

const viewData = {
    first_name: '',
    last_name: '',
    email: '',
    mobile_no: '',
    password: '',
    password_confirmation: '',
    image: '',
}

export const adminsSlice = createSlice({
    name: 'admin/admins',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = adminsSlice.actions

export default adminsSlice.reducer
